// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__19kIL","column":"style_column__2KOdd","pageScrollbar":"style_pageScrollbar__32xyS","reveal":"style_reveal__wXFit","sprSectionIn":"style_sprSectionIn__3JmKb"};